import React from "react";


export const ViewOrderHeader = () =>
{

    return (
        <div className="bg-white px-5 py-4 flex items-center shadow-nav">
            <div className="w-1 h-5 rounded-full bg-maroon mr-3"></div>
            <h1 className="font-bold text-lg text-slate-900 tracking-tight">Order receipt</h1>
        </div>
    )
}